import { render } from "./Admin.ShopProducts.ListDatatable.vue?vue&type=template&id=7a96017a"
import script from "./Admin.ShopProducts.ListDatatable.vue?vue&type=script&lang=js"
export * from "./Admin.ShopProducts.ListDatatable.vue?vue&type=script&lang=js"

import "./Admin.ShopProducts.ListDatatable.vue?vue&type=style&index=0&id=7a96017a&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__